import React from 'react'
import Nodata from '../../../../images/nodata.png'

const OverDueException = ({ tableMinPagination, tableMaxPagination, phocketTablePagination, smsData }) => (
    <div>
        {smsData && smsData.overDueExceptionMsg && smsData.overDueExceptionMsg.length>0 ?
            <div>
                <div className='credit-table'>
                    <table>
                        <thead>
                            <tr className='thead-class'>
                                <th>Bank Name</th>
                                <th>Message</th>
                                <th>Type</th>
                                <th>Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {smsData && smsData.overDueExceptionMsg ?
                                Object.entries(smsData.overDueExceptionMsg).slice(tableMinPagination, tableMaxPagination).map((data, i) => {
                                    return (
                                        <tr key={i}>
                                            <td>{data[1].bankName}</td>
                                            <td>{data[1].message}</td>
                                            <td>{data[1].messageType}</td>
                                            <td>{data[1].messageDate}</td>

                                        </tr>
                                    )
                                })
                                : ""}

                        </tbody>
                    </table>
                </div>
                <div className="container-fluid">
                    <div className="row">
                        {/* <div className="col-sm-2 col-xs-12 no-padding"> <button type="button" className="btn btn-default fa fa-chevron-left btn-lg btn-block mage" id="backword" onClick={e => phocketTablePagination(smsData.overDueExceptionMsg, 'back')}><span className="fa fa-chevron-left" /></button></div> */}
                        <div className="col-sm-5 col-xs-12 no-padding"><button type="button" className="btn btn-default fa fa-chevron-left btn-lg btn-block   " style={{ background: '#BADBF9', borderRadius: '0' }} onClick={e => phocketTablePagination(smsData.overDueExceptionMsg, 'back')}></button></div>
                        <div className="col-sm-2 col-xs-12  phoc text-center" >
                            {(tableMinPagination + 1) + ' - ' + (tableMaxPagination) + ' of ' + smsData.overDueExceptionMsg.length}
                        </div>
                        <div className="col-sm-5 col-xs-12 no-padding" ><button type="button" className="btn btn-default fa fa-chevron-right btn-lg btn-block " o style={{ background: '#BADBF9', borderRadius: '0' }} onClick={e => phocketTablePagination(smsData.overDueExceptionMsg, 'forward')}></button></div>
                        {/* <div className="col-sm-2 col-xs-12 no-padding"> <button type="button" className="btn btn-default fa fa-chevron-right btn-lg btn-block mage" id="forword" onClick={e => phocketTablePagination(smsData.salaryMsg, 'forward')}><span className="fa fa-chevron-right" /></button></div> </div> */}
                        </div>
                </div>
            </div>
            :  <div className='col-sm-12 col-xs-12 text-center'><img src={Nodata} style={{ width: '30%', marginTop: '20px' }} /></div>}
    </div>
)
export default OverDueException